import standardAPI from '@/api/standard_items';

const responseUrl = '/hotels/stars';

const state = {
  stars: [],
  stars_MetaData: {},
  stars_status: '',
  stars_page: 1,
  stars_perPage: 10,
};

const getters = {
  get_stars: (state) => {
    return state.stars;
  },
  get_stars_status: (state) => {
    return state.stars_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_stars ({ commit }, getOptions) {
    commit('DATA_STARS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_STARS_UPDATE_SUCCESS', response);
            commit('DATA_STARS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_STARS_READY');
            reject(response);
          } else {
            commit('DATA_STARS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_stars_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_star ({ commit, dispatch }, itemData) {
    commit('DATA_STARS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_STARS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_STARS_READY');
          reject(response);
        }
      });
    });
  },
  edit_star ({ commit, dispatch }, itemData) {
    commit('DATA_STARS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_STARS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_STARS_READY');
          reject(response);
        }
      });
    });
  },
  remove_stars ({ commit, dispatch }, itemData) {
    commit('DATA_STARS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_STARS_REQUEST');
          resolve();
        } else {
          commit('DATA_STARS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_star ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_star_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.stars_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.stars_perPage = max;
  },
  DATA_STARS_READY: (state) => {
    state.stars_status = 'ready';
  },
  DATA_STARS_REQUEST: (state) => {
    state.stars_status = 'loading';
  },
  DATA_STARS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.stars_MetaData.meta = response.meta;
      state.stars_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.stars = response.data || [];
    }
    state.stars_status = 'success';
  },
  DATA_STARS_ERROR: (state) => {
    state.stars_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
